"use client";

import { createContext, useContext, useState } from "react";

interface SelectedVariantImageValue {
  images: string[];
  setImages: (images: string[]) => void;
}

const SelectedVariantImageContext = createContext<SelectedVariantImageValue>({
  images: [],
  setImages: () => {},
});

export function SelectedVariantImageProvider({ children }: { children: React.ReactNode }) {
  const [images, setImages] = useState<string[]>([]);
  return (
    <SelectedVariantImageContext.Provider value={{ images, setImages }}>
      {children}
    </SelectedVariantImageContext.Provider>
  );
}

export function useSelectedVariantImage() {
  return useContext(SelectedVariantImageContext);
}
